import { OutletDetailsMetaDataItem } from "./components/OutletDetailsData"

export const outletDetailsMetaData1: OutletDetailsMetaDataItem[] = [
    {
        key: "outletChannel", 
        label: "Channel"
    },
    {
        key: "outletClass", 
        label: "Class"
    },
    {
        key: "outletAddress",
        label: "Address",
        truncateTextAfterChar: 20
    },
    {
        key: "outletCity",
        label: "City"
    }
]

export const outletDetailsMetaData2: OutletDetailsMetaDataItem[] = [
    {
        key: "outletPincode", 
        label: "Pincode"
    },
    {
        key: "outletContact", 
        label: "Contact No."
    },
    {
        key: "outletEmail",
        label: "Email ID",
        truncateTextAfterChar: 20
    },
    {
        key: "distributorCode",
        bottomKey: "supplierName",
        label: "Distributor",
        truncateTextAfterChar: 20
    }
]

export const outletDetailsMetaData3: OutletDetailsMetaDataItem[] = [
    {
        key: "salesRepCode", 
        bottomKey: "salesRepName",
        label: "Sales Rep",
        truncateTextAfterChar: 20
    },
    {
        key: "outletLatitude", 
        label: "Lat"
    },
    {
        key: "outletLongitude",
        label: "Long"
    },
    {
        key: "outletCreateDate",
        label: "Creation Date"
    }
]

export const financialDetailsMetaData1: OutletDetailsMetaDataItem[] = [
    {
        key: "paymentMode", 
        label: "Payment Mode"
    },
    {
        key: "creditLimit", 
        label: "Credit Limit"
    },
    {
        key: "creditDays",
        label: "Credit Days"
    },
    {
        key: "discountPercentage",
        label: "Discount(%)"
    }
]

export const financialDetailsMetaData2: OutletDetailsMetaDataItem[] = [
    {
        key: "cashDiscount", 
        label: "Cash Discount"
    },
    {
        key: "bank", 
        label: "Bank",
        removeKey: true
    },
    {
        key: "ifsc",
        label: "IFSC Code",
        truncateTextAfterChar: 20,
        removeKey: true
    },
    {
        key: "outletAccountNo",
        label: "Account No.",
        truncateTextAfterChar: 20
    }
]

export const shippingAndBillingDetailsMetaData1: OutletDetailsMetaDataItem[] = [
    {
        key: "outletGstin", 
        label: "Outlet GSTIN",
        truncateTextAfterChar: 20,
        removeKey: true
    },
    {
        key: "outletPan", 
        label: "PAN",
        truncateTextAfterChar: 20,
        removeKey: true        
    },
    {
        key: "shiptoGSTIN",
        label: "Ship to GSTIN",
        removeKey: true
    },
    {
        key: "shipToContactPersonName",
        label: "Contact Person Name"
    },
    {
        key: "shipToContact", 
        label: "Contact No."
    },
    {
        key: "shipToDescription", 
        label: "Description",
        truncateTextAfterChar: 20
    },
    {
        key: "shipToAddress", 
        label: "Address",
        truncateTextAfterChar: 20
    }
]

export const shippingAndBillingDetailsMetaData2: OutletDetailsMetaDataItem[] = [
    
    {
        key: "shipToCity", 
        label: "City"
    },
    {
        key: "shipToPincode",
        label: "Pincode"
    },
    {
        key: "shipToState",
        label: "State"
    }
]

export const shippingAndBillingDetailsMetaData3: OutletDetailsMetaDataItem[] = [
    {
        key: "shipToContact", 
        label: "Contact No."
    },
    {
        key: "shipToDescription", 
        label: "Description",
        truncateTextAfterChar: 20
    }
]

export const additionalDetailsMetadata1: OutletDetailsMetaDataItem[] = [
    {
        key: "outletType", 
        label: "Outlet Type"
    },
    {
        key: "outletSubChannel", 
        label: "Sub Channel"
    },
    {
        key: "loyaltyBalance",
        label: "Loyalty Balance"
    },
    {
        key: "outletCategory",
        label: "Outlet Category"
    }
]

export const additionalDetailsMetadata2 = (removeKey?: boolean): OutletDetailsMetaDataItem[]=> {
return[
    {
        key: "walletBalance", 
        label: "Wallet Balance"
    },
    {
        key: "outletPriceGroup", 
        label: "Outlet Price Group",
        removeKey: removeKey ?? false,
    },
    {
        key: "outletRoute",
        label: "Route",
        truncateTextAfterChar: 20,
    }
]}
